import React from "react";
import "./WorkOrders.css";

const WorkOrders = () => {
  return (
    <div>
      <h1>
        Lorem ipsum dolor, sit amet consectetur adipisicing elit. A, quibusdam?
      </h1>
    </div>
  );
};

export default WorkOrders;
